import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LangContext";
import { useDict } from "@/i18n/dict";
import { SHOP } from "@/constants/testIds";

const CATS = ["ebooks", "spices", "books", "tools", "pantry"];

export default function ShopPage() {
  const { lang } = useLang();
  const t = useDict(lang);
  const { add } = useCart();
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("");
  const [added, setAdded] = useState(null);

  useEffect(() => { api.listProducts(cat ? { category: cat } : {}).then(setProducts).catch(() => {}); }, [cat]);

  const handleAdd = (p) => {
    add(p, 1);
    setAdded(p.product_id);
    setTimeout(() => setAdded(null), 1200);
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 lg:pt-24">
      <p className="eyebrow mb-4">№ 03</p>
      <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl tracking-tight mb-4">{t.shop.title}</h1>
      <p className="text-lg text-[color:var(--ink-2)] max-w-2xl mb-12">{t.shop.sub}</p>

      <div className="flex flex-wrap gap-3 mb-12">
        <button data-testid={SHOP.category("all")} onClick={() => setCat("")} className={`country-chip ${cat === "" ? "active" : ""}`}>{t.shop.all}</button>
        {CATS.map((c) => (
          <button key={c} data-testid={SHOP.category(c)} onClick={() => setCat(c)} className={`country-chip ${cat === c ? "active" : ""}`}>{c}</button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-10 stagger">
        {products.map((p) => (
          <div key={p.product_id} data-testid={SHOP.productCard(p.slug)} className="product-card group">
            <Link to={`/shop/${p.slug}`} data-testid={SHOP.cardLink(p.slug)} className="block">
              <div className="product-img"><img src={p.image} alt="" /></div>
            </Link>
            <div className="pt-4">
              <Link to={`/shop/${p.slug}`} className="block">
                <h3 className="font-serif-display text-xl leading-tight hover:text-[color:var(--navy)] transition-colors">{p.name[lang] || p.name.fr}</h3>
              </Link>
              <p className="text-sm text-[color:var(--ink-2)] mt-1 line-clamp-2">{p.description[lang] || p.description.fr}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-serif-display text-2xl">{p.price.toFixed(2)} €</span>
                <button
                  data-testid={SHOP.addToCart(p.slug)}
                  onClick={() => handleAdd(p)}
                  disabled={p.stock <= 0}
                  className="text-xs tracking-[0.2em] uppercase underline hover:text-[color:var(--navy)] disabled:opacity-40 disabled:no-underline"
                >
                  {p.stock <= 0 ? t.shop.outOfStock : (added === p.product_id ? t.shop.added + " ✓" : t.shop.addToCart)}
                </button>
              </div>
              {p.is_digital && (
                <p className="mt-2 text-[10px] tracking-[0.22em] uppercase text-[color:var(--palm)] font-medium">↓ {lang === 'fr' ? 'Téléchargement instantané' : 'Instant download'}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
